import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function FirstPageModal({
  _homePageCurrent,
  _lastAccessedCurrent,
  savePrefrenceCallback,
  setHomeData,
}) {
  const { register, setValue, watch } = useFormContext();

  const home_login = watch("home_login");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    home_login ? setSelected(1) : setSelected(2);
  }, [home_login]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-evenly" style={{ gap: "5px" }}>
        <div
          className={"d-flex align-items-center gap-1 height-35"}
          // onClick={() => {
          //   setValue("home_login", true);
          //   setSelected(1);
          // }}
          onClick={() => {
            setValue("home_login", true);
            setSelected(1);
            const updated = { ...watch(), home_login: true };
            savePrefrenceCallback(updated);
            setHomeData(updated);
          }}
          style={
            {
              // width: "250px",
            }
          }
        >
          <input type="radio" {...register("home_login")} className="radio-input" readOnly />
          <div className={`radio-circle ${selected === 1 ? "checked" : ""}`} />
          <span>Home Page</span>
        </div>

        <div
          className={"d-flex align-items-center height-35  gap-1"}
          // onClick={() => {
          //   setValue("home_login", false);
          //   setSelected(2);
          // }}
          onClick={() => {
            setValue("home_login", false);
            setSelected(2);
            const updated = { ...watch(), home_login: false };
            savePrefrenceCallback(updated);
            setHomeData(updated);
          }}
          style={
            {
              // width: "250px",
            }
          }
        >
          <input type="radio" className="radio-input" readOnly />
          <div className={`radio-circle ${selected === 2 ? "checked" : ""}`} />
          <span>Last Accessed Page</span>
        </div>
      </div>
    </>
  );
}

export default FirstPageModal;
